import { tv } from '../tv';

export const sidebarNavItemVariants = tv({
  slots: {
    // colors only: collapsing the rail is instant, so the pill must not
    // animate its size either
    link: `relative flex h-9.5 cursor-pointer items-center rounded-xl text-sm tracking-tight
      transition-colors duration-200 ease-out motion-reduce:transition-none
      focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50`,
    // sits flush with the rail edge — offset mirrors the link's own inset
    indicator: 'absolute top-1/2 h-4.75 w-0.5 -translate-y-1/2 rounded-r-full bg-accent-500',
    icon: 'transition-opacity duration-200 ease-out motion-reduce:transition-none',
    label: 'truncate',
    badge:
      'ms-auto flex size-5 items-center justify-center rounded-full bg-zinc-700 text-xs font-medium text-zinc-100',
    // compact-rail stand-in for the badge: a dot on the icon's top-right
    // corner — signals "something needs attention" without a number
    dot: 'absolute end-1.5 top-1.5 size-1.5 rounded-full bg-danger-500',
  },
  variants: {
    active: {
      true: { link: 'bg-zinc-800 text-zinc-100' },
      // inactive icons recede (60% opacity, per design) so the active entry stands out
      false: {
        link: 'text-zinc-200 hover:bg-zinc-800/60 hover:text-zinc-100',
        icon: 'opacity-60',
      },
    },
    compact: {
      true: {
        // 38px square inset 3px inside the rail's 44px content box
        link: 'ms-0.75 w-9.5 justify-center',
        indicator: '-left-3.75',
        label: 'sr-only',
        badge: 'hidden',
      },
      false: {
        link: 'gap-3 px-3',
        indicator: '-left-3',
      },
    },
  },
  defaultVariants: {
    active: false,
    compact: false,
  },
});
